import { Status } from './status';
import { PlanningJob } from './planning-job';

export class Webdoku {
  id = '';
  text = '';
  description = '';
  group = '';
  location = '';
  statusBackground = '';
  statusForeground = '';
  statusSubTitle = '';
  statusTitle = '';
  redliningAllowed = false;
  copyDocumentAllowed = false;
  deleteDocumentAllowed = false;
  hasLoopNodes = false;
  hasCustomNavigation = false;
  isSubWebDoku = false;
  mainWebDokuId = '';
  mainWebDokuName = '';
  status: Status[] = [];
  planningJobs: PlanningJob[] = [];
  get hasStatus() {
    return this.status != null && this.status.length > 0;
  }
}
